export default __webpack_public_path__ + "static/media/Group 9 (1).15a9eb2e.png";